import React, {useEffect, useRef, useState} from 'react';
import {FilterMatchMode} from "primereact/api";
import {getData} from "../../../api/factura.service";
import {UsePermissions} from "../../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {Calendar} from "primereact/calendar";
import {convertirModena, exportExcel, formatFecha} from "../../../shared/utils/utils";
import {ContainerTitleTable} from "../../../components/Containers/ContainerTitleTable";
import {DataTable} from "primereact/datatable";
import {ContainerTable} from "../../../components/Containers/ContainerTable";
import {Column} from "primereact/column";

export const TableFactura = ({reload, cliente_id, obtenerParametrosFactura, nuevaFactura}) => {
    const [permisos] = UsePermissions()
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowInit, setrowInit] = useState(50);
    const [facturas, setFacturas] = useState([]);
    const toast = useRef(null);
    const initParams = {
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            'factura_id': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'num_factura': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'fecha': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'concepto_factura': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'valor': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'valor_descuento':{constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'valor_neto':{constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
            'porcen_admon': {constraints: [{value: '', matchMode: FilterMatchMode.CONTAINS}]},
        }
    };

    const [lazyParams, setLazyParams] = useState(initParams);

    async function init(datos) {
        const response = await getData(datos);
        const data = await response.data;
        return data.data;
    }

    const loadLazyData = () => {
        if (cliente_id !== '') {
            setLoading(true);
            init({lazyEvent: lazyParams, cliente_id}).then(data => {
                setLoading(false);
                // record
                setTotalRecords(data.total);
                // total
                setFacturas(data.record);
                setLoading(false);
            });
        }

    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onPage = (event) => {
        setrowInit(event.rows);
        setLazyParams(event);
    }

    const laziParamsInit = () => {
        setLazyParams(initParams);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    useEffect(() => {
        if (cliente_id !== '') {
            loadLazyData();
        }

        return () => {
            // record
            if (cliente_id !== '') {
                setTotalRecords(0);
                setFacturas([]);
            }

        }
    }, [lazyParams])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (reload && cliente_id !== '') {
            loadLazyData();
        }
        return () => {
        }
    }, [reload]);


    useEffect(() => {
        if (cliente_id !== "") {
            loadLazyData();
        }
        return () => {
        }
    }, [cliente_id]);

    const dateFilterTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)}
                         dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999"/>
    }

    const dateBodyTemplate = (rowData) => {
        return formatFecha(rowData.fecha)
    }

    const valueBodyTemplate = (rowData) => {
        return convertirModena(rowData.valor_factura);
    }

    const valueBodyTemplateDes = (rowData) => {
        return convertirModena(rowData.valor_descuento);
    }

    const valueBodyTemplateNet = (rowData) => {
        return convertirModena(rowData.valor_neto);
    }

    const valueBodyTemplatePorce = (rowData) => {
        return rowData.porcen_admon + '%';
    }


    const header = (
        <div className="flex align-items-center justify-between">
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.adicionar)}
                    onClick={nuevaFactura}
                >
                    <i className="fa fa-file"/>
                </button>
            </div>
            <div>
                <button
                    className="secundary-color-btn btn"
                    type="button"
                    disabled={(!permisos.consultar)}
                    onClick={loadLazyData}
                >
                    <i className="fa fa-search"/>
                </button>

                <button
                    onClick={laziParamsInit}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-filter"/>
                </button>
                <button
                    onClick={() => exportExcel(facturas, "facturas")}
                    disabled={(!permisos.consultar)}
                    className="secundary-color-btn btn"
                    type="button"
                >
                    <i className="fa fa-print"/>
                </button>
            </div>

        </div>
    );
    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn primary-color-btn"
                    type="button"
                    onClick={() => obtenerParametrosFactura(rowData)}>
                    <i className="fa fa-user-edit"/>
                </button>
            </div>
        );
    }



    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    showGridlines
                    header={header}
                    resizableColumns
                    columnResizeMode="expand"

                    size="small"
                    value={facturas}
                    lazy
                    filterDisplay="menu"
                    first={lazyParams.first}
                    totalRecords={totalRecords}
                    onPage={onPage}
                    onSort={onSort}
                    sortField={lazyParams.sortField}
                    sortOrder={lazyParams.sortOrder}
                    onFilter={onFilter}
                    filters={lazyParams.filters}
                    loading={loading}
                    paginator
                    scrollable scrollHeight="500px"
                    rows={rowInit}
                    rowsPerPageOptions={[50, 100, 300, 500]}

                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} facturas"
                    responsiveLayout="scroll">

                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>
                    <Column field="num_factura" header="Nro factura" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="fecha" header="Fecha" body={dateBodyTemplate} sortable filter
                            showFilterMatchModes={false}
                            filterElement={dateFilterTemplate}
                            dataType="date"
                            onFilterClear={laziParamsInit}/>
                    <Column field="concepto_factura" header="Concepto" sortable filter showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}></Column>
                    <Column field="valor" body={valueBodyTemplate} header="Valor" sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>

                    <Column field="valor_descuento" body={valueBodyTemplateDes} header="Valor gasto" sortable filter
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>

                    <Column field="valor_neto"  body={valueBodyTemplateNet}  header="Valor neto"
                            filter sortable
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>
                    <Column field="porcen_admon"  body={valueBodyTemplatePorce}  header="Porcentaje admi"
                            filter sortable
                            showFilterMatchModes={false}
                            onFilterClear={laziParamsInit}/>
                </DataTable>

            </ContainerTable>
        </>
    );
};

TableFactura.defaultProps = {
    reload: false,
    cliente_id: ""
};
